/**
 *
 * @return {ApiHeaders}
 */
export const getHeaders = (apiConfig = {}) => {
    const headers = {
        accept: 'application/json',
    };
    if (apiConfig.clientId) {
        headers['x-anwb-client-id'] = apiConfig.clientId;
    }
    if (apiConfig.clientSecret) {
        headers['x-anwb-client-secret'] = apiConfig.clientSecret;
    }
    if (apiConfig.appId) {
        headers['x-anwb-statistics-application'] = apiConfig.appId;
    }
    return headers;
};
